module.exports = __webpack_public_path__ + "static/Chloe_Sharrock-d81ff0157f23405dfa75f3272e113c81.png";